import React from 'react';
import { AlertCircle, CheckCircle2, Info, RefreshCw, TriangleAlert, X, Check } from 'lucide-react';
export const ToastItem = ({ toast, onDismiss, }) => {
    const getVariantStyles = (type) => {
        switch (type) {
            case 'success':
                return {
                    borderColor: 'border-green-500',
                    iconColor: 'text-green-500',
                    title: 'Success',
                    progressColor: '#16a34a',
                };
            case 'warning':
                return {
                    borderColor: 'border-amber-500',
                    iconColor: 'text-amber-500',
                    title: 'Warning',
                    progressColor: '#f59e0b',
                };
            case 'info':
                return {
                    borderColor: 'border-blue-500',
                    iconColor: 'text-blue-500',
                    title: 'Info',
                    progressColor: '#3b82f6',
                };
            case 'error':
            default:
                return {
                    borderColor: 'border-red-500',
                    iconColor: 'text-red-500',
                    title: 'Error',
                    progressColor: '#dc2626',
                };
        }
    };
    const getIcon = (type) => {
        switch (type) {
            case 'success':
                return CheckCircle2;
            case 'warning':
                return TriangleAlert;
            case 'info':
                return Info;
            case 'error':
            default:
                return AlertCircle;
        }
    };
    const getActionButtonStyles = (kind) => {
        switch (kind) {
            case 'Retry':
                return {
                    bgColor: 'bg-red-600',
                    hoverColor: 'hover:bg-red-700',
                    disabledColor: 'disabled:bg-red-400',
                    icon: RefreshCw,
                };
            case 'I Understand':
                return {
                    bgColor: 'bg-blue-600',
                    hoverColor: 'hover:bg-blue-700',
                    disabledColor: 'disabled:bg-blue-400',
                    icon: Check,
                };
            default:
                // Default to Retry styling if no kind specified
                return {
                    bgColor: 'bg-red-600',
                    hoverColor: 'hover:bg-red-700',
                    disabledColor: 'disabled:bg-red-400',
                    icon: RefreshCw,
                };
        }
    };
    const variant = getVariantStyles(toast.type);
    const IconComp = getIcon(toast.type);
    return (React.createElement("div", { className: "z-50 transition-all duration-300 ease-in-out", style: {
            maxWidth: '400px',
            animation: 'slideInFromTop 0.3s ease-out',
            top: '16px'
        } },
        React.createElement("div", { className: `bg-white rounded-lg shadow-lg border-l-4  ${variant.borderColor} p-4 flex items-start gap-3` },
            React.createElement(IconComp, { className: `w-5 h-5 ${variant.iconColor} flex-shrink-0 mt-0.5 ` }),
            React.createElement("div", { className: "flex-1 min-w-0" },
                React.createElement("div", { className: "flex items-center justify-between gap-2 mb-1" },
                    React.createElement("h4", { className: "font-semibold text-gray-900 text-sm" }, variant.title),
                    React.createElement("button", { onClick: () => onDismiss(toast.id), className: "text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0", "aria-label": "Dismiss" },
                        React.createElement(X, { className: "w-4 h-4" }))),
                React.createElement("p", { className: "text-sm text-gray-600 mb-2 break-words" }, toast.message),
                toast?.actionButton && (() => {
                    const actionStyles = getActionButtonStyles(toast.actionButton.kind);
                    const ActionIcon = actionStyles.icon;
                    return (React.createElement("button", { onClick: () => {
                            toast?.actionButton?.onClick();
                            onDismiss(toast.id);
                        }, className: `inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-white ${actionStyles.bgColor} ${actionStyles.hoverColor} ${actionStyles.disabledColor} disabled:cursor-not-allowed rounded-md transition-colors` },
                        React.createElement(ActionIcon, { className: "w-4 h-4" }),
                        toast.actionButton.kind));
                })()))));
};
